import { api } from '../api'

export interface RequestWorkersPayload {
  shift_ids: number[]
  additional_workers: number
  specific_worker_ids_to_request?: string[]
  roster_ids?: number[]
  roster_perm_hold?: boolean
}

export const requestWorkers = async (
  companyId: number,
  assignmentId: number,
  payload: RequestWorkersPayload
) => {
  await api.put(
    `/company/${companyId}/assignment/${assignmentId}/shifts/add_workers`,
    payload
  )
}
